import React from 'react'
import { IArticleHead } from '../../../interfaces/article'
import ArticleThumbnail from '../../articleList/thumbnail.component'

interface IHomePagePopupContent {
  data: IArticleHead
}
const HomePagePopupContent: React.FC<IHomePagePopupContent> = ({ data }) => {
  return (
    <div className='w-[85vw] md:w-[80vw] xl:w-[80vw] h-full md:h-[95vh] xl:h-[50vh] flex flex-col justify-center items-center bg-modal-bg p-8 gap-desktop '>
      <div className='w-full xl:w-2/3 '>
        <ArticleThumbnail articleHead={data} isRelatedArticle={false} />
      </div>
    </div>
  )
}

export default HomePagePopupContent
